import React from 'react';
import ProofOne from '../../../../../assets/images/proof-1.png';
import ProofTwo from '../../../../../assets/images/proof-2.png';
import ProofThree from '../../../../../assets/images/proof-3.png';

const StarIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="#FD9926">
    <path d="M8 1.25l1.854 3.756L14 5.638l-3 2.924.708 4.128L8 10.673l-3.708 2.017L5 8.562 2 5.638l4.146-.632L8 1.25z" />
  </svg>
);

const QuoteIcon = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
    <path d="M4 20c0-5.333 3.2-10.133 9.6-14.4L15.2 8C11.467 10.4 9.333 13.067 9.333 16H12v8H4v-4zm14 0c0-5.333 3.2-10.133 9.6-14.4L29.2 8C25.467 10.4 23.333 13.067 23.333 16H26v8H18v-4z" fill="#0C4767" fillOpacity="0.08" />
  </svg>
);

const testimonials = [
  {
    comment: 'MeetOcto has completely simplified how my team schedules meetings. No more endless back-and-forth emails!',
    userImg: ProofOne,
    userName: 'Sarah Lopez',
    userJob: 'Marketing Manager',
    company: 'TechCorp',
    rating: 5,
  },
  {
    comment: 'I love how easy it is to see everyone\'s availability. MeetOcto saves me so much time every week.',
    userImg: ProofTwo,
    userName: 'James Patel',
    userJob: 'Product Designer',
    company: 'Designify',
    rating: 5,
  },
  {
    comment: 'Our team\'s productivity has skyrocketed since we started using MeetOcto. Scheduling has never been this smooth!',
    userImg: ProofThree,
    userName: 'Michael Chen',
    userJob: 'Sales Lead',
    company: 'GrowthHQ',
    rating: 5,
  },
];

export const SocialProofView = () => {
  return (
    <section id="testimonials" className="testimonials-section">
      <div className="testimonials-section__inner">
        <div className="testimonials-section__header">
          <span className="testimonials-section__label">Trusted by Professionals</span>
          <h2 className="testimonials-section__title">What Our Users Say</h2>
          <p className="testimonials-section__subtitle">
            Join thousands of professionals who save hours every week with MeetOcto.
          </p>
        </div>

        <div className="testimonials-grid">
          {testimonials.map((t, index) => (
            <div className="testimonial-card" key={index}>
              <div className="testimonial-card__quote">
                <QuoteIcon />
              </div>
              <div className="testimonial-card__stars">
                {Array.from({ length: t.rating }).map((_, i) => <StarIcon key={i} />)}
              </div>
              <p className="testimonial-card__comment">"{t.comment}"</p>
              <div className="testimonial-card__author">
                <img src={t.userImg} alt={t.userName} className="testimonial-card__avatar" />
                <div className="testimonial-card__info">
                  <span className="testimonial-card__name">{t.userName}</span>
                  <span className="testimonial-card__role">{t.userJob}{t.company ? `, ${t.company}` : ''}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
